export default __webpack_public_path__ + "static/media/check-circle.5a97e856.svg";